import { useEffect, useState } from "react";
import { FaTimes, FaTimesCircle } from "react-icons/fa";
import SearchIcon from '@mui/icons-material/Search';
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import Button from '@mui/material/Button';

const HistorialCancelaciones = () => {

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [brandName, setBrandName] = useState("");

  const [record, setRecord] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [missingPayment, setMissingPayment] = useState(true);

  const getRecord = async () => {
    try {

      setLoading(true)
      let url = `${BACKEND}/api/getHistorialCancelaciones?page=${page}&limit=${limit}`

      if (missingPayment) {
        url += `&missedPayments=${missingPayment}`
      }
      if (brandName) {
        url += `&brandName=${brandName}`
      }
  
      const response = await axios.get(url)

      setRecord(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      return null
    } finally {
      setLoading(false)
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getRecord()
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  useEffect(() => {
    getRecord()
  }, [page, limit, missingPayment])

  useEffect(() => { 
    if (brandName === "") {
      getRecord(); 
      setPage(1); 
    }
  }, [brandName]);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaTimesCircle className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Historial de cancelaciones</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Totales */}
      <div className="flex bg-gray-100 mt-0.5 py-1 justify-between items-center w-full gap-10">
        <div className="flex flex-row w-full items-center px-16 gap-4 justify-end overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-1 items-center justify-center px-6">
            <span className="text-xs font-bold">Total:</span>
            <span className="text-xs"> S/. {record.reduce((acc, e) => acc + e.payments.reduce((acc, p) => acc + p.precio, 0), 0).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto mt-0.5">
        {loading ? (
            <LoadingScreen />
          ) : (
            record.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full text-xs">
                <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                  <tr className="text-gray-700 text-center text-xs font-bold">
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cliente
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Monto
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {record?.map((e) => {
                  // {record.sort((a, b) => b.payments.reduce((acc, p) => acc + p.precio, 0) - a.payments.reduce((acc, p) => acc + p.precio, 0)).map((e) => {
                    return (
                      <tr className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300">
                        <td scope="row" className="px-2 py-1 max-w-xs border font-bold border-gray-300 truncate text-start">
                          {e.nombreComercial}
                        </td>
                        <td scope="row" className="px-2 py-1 max-w-xs border font-bold border-gray-300 truncate text-center">
                          {e.payments.reduce((acc, p) => acc + p.precio, 0).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"cancelaciones"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(event, value) => setPage(value)}
      />

    </div>
  )
}

export default HistorialCancelaciones;  